import React from 'react'

export default function DailySalesInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        .daily-sales-report-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }

        .header-wrapper { }

        .top-container { flex: 1; }

        .daily-sales-report-table {
          width: 100%;
          border: solid 0.5px black;
          border-spacing: 0;
        }

        .daily-sales-report-table td { padding: 5px 10px; }
        .daily-sales-report-table th { padding: 10px 10px; }

        .striped tbody:nth-child(even) { background-color: #F7FFF7; }
        .daily-sales-report-table thead { background-color: #A7ADB8; }
        .daily-sales-report-table td { text-align: right; }
        .daily-sales-report-table .total { background-color: lightblue; font-weight: bold; }

        .bottom-container { width: 70%; }

        .lastpage { margin-bottom: 25px; }

        .monthly-sales-chart { display: flex; }
      `}
      </style>
    </React.Fragment>
  )
}
